import {
  LOGIN_FORM_SUBMIT,
  REGISTER_FORM_SUBMIT,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILED,
  ON_PASSWORD_UPDATE,
  LOAD_PROFILE_SUCCESS,
  LOAD_PROFILE_FAILED,
  LOAD_PROFILE_START,
  CLOSE_PROFILE_SNACKBAR,
  REGISTER_FORM_SUBMIT_SUCCESS,
  REGISTER_FORM_SUBMIT_FAILED,
  REGISTER_FORM_SUBMIT_USER_EXIST_ERROR,
  CLOSE_REGISTER_SNACKBAR,
  LOAD_REGISTER_FROM_SITE,
  LOGIN_FORM_SUBMIT_SUCCESS,
  LOGIN_FORM_SUBMIT_FAILED,
  CLOSE_LOGIN_SNACKBAR,
  CLIENT_SET,
  CLIENT_UNSET,
  LOGOUT,
  GET_LANG_FROM_SITE,
  RESET_PASSWORD_FORM_SUBMIT,
  RESET_PASSWORD_SUBMIT_SUCCESS,
  RESET_PASSWORD_SUBMIT_FAILED,
  HIDE_RESET_PASSWORD_SNACKBAR,
  PASSWORD_UPDATE_SUCCESS,
  PASSWORD_UPDATE_FAILED,
  CLOSE_PASSWORD_SNACKBAR,
  LANGUAGE_CHANGE,
  VALIDATE_TOKEN,
  GET_FIELD_OF_WORK,
  ADD_LIGHT_ENTREPRENEURS,
  ADD_LIGHT_ENTREPRENEURS_SUCCESS,
  ADD_LIGHT_ENTREPRENEURS_FAILED,
  GET_LIGHT_ENTREPRENEURS,
  GET_LIGHT_ENTREPRENEURS_SUCCESS,
  GET_LIGHT_ENTREPRENEURS_FAILED,
  SET_FAVOURITE_ENTREPRENEURS,
  SET_FAVOURITE_ENTREPRENEURS_FAILED,
  LIGHT_ENTREPRENEURS_PAGE_CHANGE,
  OFFER_AN_ASSIGNMENT_AGREEMENT,
  CANCEL_OFFER,
  COMPLETE_OFFER_FORM,
  GET_E_INVOICE_OPERATORS,
  GET_E_INVOICE_OPERATORS_SUCCESS,
  GET_E_INVOICE_OPERATORS_FAILED,
  GET_FIELD_OF_WORK_SUCCESS,
  CHANGE_ROWS_PER_PAGE,
  REMOVE_LIGHT_ENTREPRENEURS,
  REMOVE_LIGHT_ENTREPRENEURS_SUCCESS,
  REMOVE_LIGHT_ENTREPRENEURS_FAILED,
  CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR,
  PREVIEW_CONTRACT,
  PREVIEW_CONTRACT_SUCCESS,
  PREVIEW_CONTRACT_FAILED,
  LOAD_PREVIEW_PDF,
  CLOSE_LOAD_PREVIEW_PDF,
  SIGN_CONTRACT_SCREEN,
  GET_ASSIGNMENTS,
  GET_ASSIGNMENTS_SUCCESS,
  GET_ASSIGNMENTS_FAILED,
  PREVIEW_NEW_ASSIGNMENT,
  CLOSE_PREVIEW_NEW_ASSIGNMENT,
  ADD_NEW_ASSIGNMENT,
  ADD_NEW_ASSIGNMENT_SUCCESS,
  ADD_NEW_ASSIGNMENT_FAILED,
  GET_ASSIGNMENT_BY_ID,
  GET_ASSIGNMENT_BY_ID_SUCCESS,
  GET_ASSIGNMENT_BY_ID_FAILED,
  SET_ASSIGNMENT_FORM_READONLY,
  CANCEL_EDIT_ASSIGNMENT,
  UPDATE_ASSIGNMENT_SUCCESS,
  DELETE_ASSIGNMENT,
  DELETE_ASSIGNMENT_SUCCESS,
  CLOSE_ASSIGNMENT_SNACKBAR,
  COPY_ASSIGNMENT,
  COPY_ASSIGNMENT_SUCCESS,
  COPY_ASSIGNMENT_FAILED,
  UPDATE_ASSIGNMENT_FAILED,
  SAVE_ASSIGNMENT_AS_DRAFT,
  SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS,
  SAVE_ASSIGNMENT_AS_DRAFT_FAILED,
  SIGN_AND_SEND_CONTRACT,
  SIGN_AND_SEND_CONTRACT_SUCCESS,
  SIGN_AND_SEND_CONTRACT_FAILED,
  GET_APPLICANT_DETAILS,
  GET_APPLICANT_DETAILS_SUCCESS,
  GET_APPLICANT_DETAILS_FAILED,
  SELECTED_APPLICANT,
  UPDATE_VIEW_APPLICATION,
  UPDATE_REVIEW_APPLICATION,
  UPDATE_REVIEW_APPLICATION_SUCCESS,
  UPDATE_REVIEW_APPLICATION_FAILED,
  FILTER_APPLICANTS,
  GET_TOTAL_APPLICATIONS,
  GET_TOTAL_APPLICATIONS_SUCCESS,
  GET_TOTAL_APPLICATIONS_FAILED,
  REJECT_APPLICATION,
  REJECT_APPLICATION_SUCCESS,
  REJECT_APPLICATION_FAILED,
  OFFER_ASSIGNMENT,
  APPLICATION_SAVE_ASSIGNMENT,
  EDIT_ASSIGNMENT,
  PREVIEW_ASSIGNMENT,
  PREVIEW_ASSIGNMENT_SUCCESS,
  PREVIEW_ASSIGNMENT_FAILED,
  SIGN_ASSIGNMENT_PAD,
  SIGN_SEND_CONTRACT,
  SIGN_SEND_CONTRACT_SUCCESS,
  SIGN_SEND_CONTRACT_FAILED,
  REJECT_WARNING,
  GET_WORKSHIFTS,
  GET_WORKSHIFTS_SUCCESS,
  GET_WORKSHIFTS_FAILED,
  GET_BILLABLE_HOURS,
  GET_BILLABLE_HOURS_SUCCESS,
  GET_BILLABLE_HOURS_FAILED,
  ADD_WORKSHIFTS,
  ADD_WORKSHIFTS_SUCCESS,
  ADD_WORKSHIFTS_FAILED,
  GET_WORKSHIFT_BY_ID,
  GET_WORKSHIFT_BY_ID_SUCCESS,
  GET_WORKSHIFT_BY_ID_FAILED,
  CONFIRM_BILLABLE_HOUR,
  CONFIRM_BILLABLE_HOUR_SUCCESS,
  CONFIRM_BILLABLE_HOUR_FAILED,
  DELETE_WORKSHIFT,
  CANCEL_DIALOG,
  REMOVE_WORKSHIFT,
  REMOVE_WORKSHIFT_SUCCESS,
  REMOVE_WORKSHIFT_FAILED,
  UPDATE_WORKSHIFT,
  UPDATE_WORKSHIFT_SUCCESS,
  UPDATE_WORKSHIFT_FAILED,
  COPY_PREVIOUS_ASSIGNMENT,
  COPY_PREVIOUS_ASSIGNMENT_SUCCESS,
  COPY_PREVIOUS_ASSIGNMENT_FAILED,
  LOAD_SIGN_AND_SEND,
  CLOSE_LOAD_SIGN_AND_SEND,
  CANCEL_EDIT_WORK_SHIFT,
  CLOSE_WORKSHIFT_SNACKBAR,
  GET_SIGNED_LIGHT_ENTREPRENEUS,
  GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS,
  GET_SIGNED_LIGHT_ENTREPRENEUS_FAILED,
  WORKSHIFT_BY_EMAIL,
  CLOSE_APPLICATION_SNACKBAR,
  UPDATE_APPLICATION_STATUS,
  UPDATE_APPLICATION_STATUS_SUCCESS,
  UPDATE_APPLICATION_STATUS_FAILED,
  GET_AREA_OF_WORK,
  GET_AREA_OF_WORK_SUCCESS,
  GET_OFFER_FROM_LIGHT_ENTRE,
  GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS,
  GET_OFFER_FROM_LIGHT_ENTRE_FAILED,
  CLOSE_SIGN_CONTRACT_SCREEN,
  OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM,
  GET_CONTRACT,
  GET_CONTRACT_FAILED,
  GET_CONTRACT_SUCCESS,
  GET_EMPLOYER_CONTRACT_LIST,
  GET_EMPLOYER_CONTRACT_LIST_SUCCESS,
  GET_EMPLOYER_CONTRACT_LIST_FAILED,
  APPLICATION_PAGE_CHANGE,
  PIN_APPLICATION,
  PIN_APPLICATION_SUCCESS,
  PIN_APPLICATION_FAILED,
  WORKSHIFT_PAGE_CHANGE,
  PIN_WORKSHIFT,
  SHOW_WORKSHIFT_FORM_DIALOG,
  CLOSE_WORKSHIFT_FORM_DIALOG,
  OPEN_ASSIGNMENT_FORM_DIALOG,
  CLOSE_ASSIGNMENT_FORM_DIALOG,
  ASSIGNMENT_PAGE_CHANGE,
  PIN_ASSIGNMENT,
  PIN_ASSIGNMENT_SUCCESS,
  PIN_ASSIGNMENT_FAILED,
  PIN_WORKSHIFT_SUCCESS,
  PIN_WORKSHIFT_FAILED
} from '../../constants/employer/index'

export const updateProfile = (formValues) => ({
  type: UPDATE_PROFILE,
  formValues
})
export const updateProfileSuccess = (result) => ({
  type: UPDATE_PROFILE_SUCCESS,
  result
})
export const updateProfileFailed = () => ({ type: UPDATE_PROFILE_FAILED })

export const passwordUpdate = (formValues) => ({
  type: ON_PASSWORD_UPDATE,
  formValues
})
export const passwordUpdateSuccess = (result) => ({
  type: PASSWORD_UPDATE_SUCCESS,
  result
})
export const passwordUpdateFailed = (error) => ({
  type: PASSWORD_UPDATE_FAILED,
  error
})
export const loadProfileStart = (data) => ({ type: LOAD_PROFILE_START, data })
export const closeProfileSnackbar = () => ({ type: CLOSE_PROFILE_SNACKBAR })

export const loadProfileSuccess = (result) => ({
  type: LOAD_PROFILE_SUCCESS,
  result
})
export const loadProfileFailed = (error) => ({
  type: LOAD_PROFILE_FAILED,
  error
})
export const closePasswordSnackbar = () => ({ type: CLOSE_PASSWORD_SNACKBAR })

export const loginFormSubmit = (values) => ({ type: LOGIN_FORM_SUBMIT, values })

export const loginFormSubmitSuccess = () => ({
  type: LOGIN_FORM_SUBMIT_SUCCESS
})
export const loginFormSubmitFailed = (error) => ({
  type: LOGIN_FORM_SUBMIT_FAILED,
  error
})
export const closeLoginSnackbar = () => ({ type: CLOSE_LOGIN_SNACKBAR })
export const setClient = (token) => ({ type: CLIENT_SET, token })
export const unsetClient = () => ({ type: CLIENT_UNSET })
export const logout = () => ({ type: LOGOUT })
export const getLangFromSite = () => ({ type: GET_LANG_FROM_SITE })
export const resetPasswordFormSubmit = (formValues) => ({
  type: RESET_PASSWORD_FORM_SUBMIT,
  formValues
})
export const resetPasswordSubmitSuccess = () => ({
  type: RESET_PASSWORD_SUBMIT_SUCCESS
})
export const resetPasswordSubmitFailed = () => ({
  type: RESET_PASSWORD_SUBMIT_FAILED
})
export const hideResetPasswordSnackbar = () => ({
  type: HIDE_RESET_PASSWORD_SNACKBAR
})

export const registerFormSubmit = (values) => ({
  type: REGISTER_FORM_SUBMIT,
  values
})
export const registerFormSubmitSuccess = (result) => ({
  type: REGISTER_FORM_SUBMIT_SUCCESS,
  result
})
export const registerFormSubmitFailed = (error) => ({
  type: REGISTER_FORM_SUBMIT_FAILED,
  error
})
export const registerFormSubmitUserExistError = (error) => ({
  type: REGISTER_FORM_SUBMIT_USER_EXIST_ERROR,
  error
})
export const closeRegisterSnackbar = () => ({ type: CLOSE_REGISTER_SNACKBAR })
export const loadSignUpFromSite = () => ({ type: LOAD_REGISTER_FROM_SITE })

export const handleChangeLang = (lang) => ({ type: LANGUAGE_CHANGE, lang })

export const validateToken = (isUserActive) => ({
  type: VALIDATE_TOKEN,
  isUserActive
})

// huong - EMPLOPYERS LOGIN APPLICATION

export const getOperatorsEinvoice = () => ({ type: GET_E_INVOICE_OPERATORS })
export const getOperatorsEinvoiceSuccess = (operators) => ({
  type: GET_E_INVOICE_OPERATORS_SUCCESS,
  operators
})
export const getOperatorsEinvoiceFailed = (error) => ({
  type: GET_E_INVOICE_OPERATORS_FAILED,
  error
})

export const getFieldOfWork = () => ({ type: GET_FIELD_OF_WORK })
export const getFieldOfWorkSuccess = (data) => ({
  type: GET_FIELD_OF_WORK_SUCCESS,
  data
})

export const addLightEntrepreneurs = (values) => ({
  type: ADD_LIGHT_ENTREPRENEURS,
  values
})
export const addLightEntrepreneursSuccess = (data) => ({
  type: ADD_LIGHT_ENTREPRENEURS_SUCCESS,
  data
})
export const addLightEntrepreneursFailed = (error) => ({
  type: ADD_LIGHT_ENTREPRENEURS_FAILED,
  error
})

export const removeLightEntrepreneurs = (values) => ({
  type: REMOVE_LIGHT_ENTREPRENEURS,
  values
})
export const removeLightEntrepreneursSuccess = (data) => ({
  type: REMOVE_LIGHT_ENTREPRENEURS_SUCCESS,
  data
})
export const removeLightEntrepreneursFailed = (error) => ({
  type: REMOVE_LIGHT_ENTREPRENEURS_FAILED,
  error
})

export const getLightEntrepreneurs = (values) => ({
  type: GET_LIGHT_ENTREPRENEURS,
  values
})

export const getLightEntrepreneurSuccess = (data, selectedLE) => ({
  type: GET_LIGHT_ENTREPRENEURS_SUCCESS,
  data,
  selectedLE
})

export const getLightEntrepreneursFailed = (error) => ({
  type: GET_LIGHT_ENTREPRENEURS_FAILED,
  error
})

export const setFavouriteEntrepreneurs = (values) => ({
  type: SET_FAVOURITE_ENTREPRENEURS,
  values
})

export const setFavouriteEntrepreneursFailed = (error) => ({
  type: SET_FAVOURITE_ENTREPRENEURS_FAILED,
  error
})

export const lightEntrepreneursPageChange = (selected) => ({
  type: LIGHT_ENTREPRENEURS_PAGE_CHANGE,
  selected
})

export const offerAnAssignmentAgreement = (selected) => ({
  type: OFFER_AN_ASSIGNMENT_AGREEMENT,
  selected
})

export const cancelOffer = () => ({
  type: CANCEL_OFFER
})

export const completeOfferForm = (selected, assignmentData) => ({
  type: COMPLETE_OFFER_FORM,
  selected,
  assignmentData
})

export const openWarningCloseCompleteOfferForm = () => ({
  type: OPEN_WARNING_CLOSE_COMPLETE_OFFER_FORM
})
export const closeWarningCloseCompleteOfferForm = () => ({
  type: CLOSE_WARNING_CLOSE_COMPLETE_OFFER_FORM
})

export const closeLightEntrepreneursSnackbar = () => ({
  type: CLOSE_LIGHT_ENTREPRENEURS_SNACKBAR
})

export const previewContract = (formValues) => ({
  type: PREVIEW_CONTRACT,
  formValues
})
export const previewContractSuccess = (data) => ({
  type: PREVIEW_CONTRACT_SUCCESS,
  data
})
export const previewContractFailed = (error) => ({
  type: PREVIEW_CONTRACT_FAILED,
  error
})
export const loadPreviewPdf = () => ({
  type: LOAD_PREVIEW_PDF
})
export const closeLoadPreviewPdf = () => ({
  type: CLOSE_LOAD_PREVIEW_PDF
})
export const loadSignAndSend = () => ({
  type: LOAD_SIGN_AND_SEND
})
export const closeLoadSignAndSend = () => ({
  type: CLOSE_LOAD_SIGN_AND_SEND
})
export const signContractScreen = () => ({
  type: SIGN_CONTRACT_SCREEN
})
export const closeSignContractScreen = () => ({
  type: CLOSE_SIGN_CONTRACT_SCREEN
})
export const signAndSendContract = (trim, isDraft) => ({
  type: SIGN_AND_SEND_CONTRACT,
  trim,
  isDraft
})
export const signAndSignContractSuccess = (data) => ({
  type: SIGN_AND_SEND_CONTRACT_SUCCESS,
  data
})
export const signAndSignContractFailed = (error) => ({
  type: SIGN_AND_SEND_CONTRACT_FAILED,
  error
})

export const changeRowsPerPage = (rows) => ({
  type: CHANGE_ROWS_PER_PAGE,
  rows
})

export const getAssignments = (isDirectlyOffer) => ({
  type: GET_ASSIGNMENTS,
  isDirectlyOffer
})
export const getAssignmentsSuccess = (data) => ({
  type: GET_ASSIGNMENTS_SUCCESS,
  data
})
export const getAssignmentsFailed = (error) => ({
  type: GET_ASSIGNMENTS_FAILED,
  error
})
export const assignmentPageChange = (selected) => ({
  type: ASSIGNMENT_PAGE_CHANGE,
  selected
})
export const previewNewAssignment = (values) => ({
  type: PREVIEW_NEW_ASSIGNMENT,
  values
})
export const closePreviewNewAssignment = () => ({
  type: CLOSE_PREVIEW_NEW_ASSIGNMENT
})
export const addNewAssignment = (values, isDirectlyOffer) => ({
  type: ADD_NEW_ASSIGNMENT,
  values,
  isDirectlyOffer // Is directly offer an assignment agreement right away after created assignment
})
export const addNewAssignmentSuccess = (data) => ({
  type: ADD_NEW_ASSIGNMENT_SUCCESS,
  data
})
export const addNewAssignmentFailed = (error) => ({
  type: ADD_NEW_ASSIGNMENT_FAILED,
  error
})
export const getAssignmentById = (id) => ({
  type: GET_ASSIGNMENT_BY_ID,
  id
})
export const getAssignmentByIdSuccess = (result) => ({
  type: GET_ASSIGNMENT_BY_ID_SUCCESS,
  result
})
export const getAssignmentByIdFailed = (error) => ({
  type: GET_ASSIGNMENT_BY_ID_FAILED,
  error
})
export const setAssignmentFormReadOnly = (isReadOnly) => ({
  type: SET_ASSIGNMENT_FORM_READONLY,
  payload: isReadOnly
})
export const cancelEditAssignment = () => ({
  type: CANCEL_EDIT_ASSIGNMENT
})
export const updateAssignmentSuccess = (data) => ({
  type: UPDATE_ASSIGNMENT_SUCCESS,
  data
})
export const updateAssignmentFailed = (error) => ({
  type: UPDATE_ASSIGNMENT_FAILED,
  error
})
export const deleteAssignment = (id) => ({
  type: DELETE_ASSIGNMENT,
  id
})
export const deleteAssignmentSuccess = (data) => ({
  type: DELETE_ASSIGNMENT_SUCCESS,
  data
})
export const deleteAssignmentFailed = (error) => ({
  error
})
export const closeAssignmentSnackbar = () => ({
  type: CLOSE_ASSIGNMENT_SNACKBAR
})
export const copyAssignment = (id) => ({
  type: COPY_ASSIGNMENT,
  id
})
export const copyAssignmentSuccess = (result) => ({
  type: COPY_ASSIGNMENT_SUCCESS,
  result
})
export const copyAssignmentFailed = (error) => ({
  type: COPY_ASSIGNMENT_FAILED,
  error
})
export const saveAssignmentAsDraft = (values) => ({
  type: SAVE_ASSIGNMENT_AS_DRAFT,
  values
})
export const saveAssignmentAsDraftSuccess = (data) => ({
  type: SAVE_ASSIGNMENT_AS_DRAFT_SUCCESS,
  data
})
export const saveAssignmentAsDraftFailed = (error) => ({
  type: SAVE_ASSIGNMENT_AS_DRAFT_FAILED,
  error
})
export const getEmployerContractList = () => ({
  type: GET_EMPLOYER_CONTRACT_LIST
})
export const getEmployerContractListSuccess = (data) => ({
  type: GET_EMPLOYER_CONTRACT_LIST_SUCCESS,
  data
})
export const getEmployerContractListFailed = (error) => ({
  type: GET_EMPLOYER_CONTRACT_LIST_FAILED,
  error
})
export const pinAssignment = (assignment_id) => ({
  type: PIN_ASSIGNMENT,
  assignment_id
})
export const pinAssignmentSuccess = (data) => ({
  type: PIN_ASSIGNMENT_SUCCESS,
  data
})
export const pinAssignmentFailed = (error) => ({
  type: PIN_ASSIGNMENT_FAILED,
  error
})

export const handleRefreshClick = () => {
  window.location.reload()
}

export const getApplicantDetails = () => ({
  type: GET_APPLICANT_DETAILS
})
export const getApplicantDetailsSuccess = (data) => ({
  type: GET_APPLICANT_DETAILS_SUCCESS,
  data
})
export const getApplicantDetailsFailed = (error) => ({
  type: GET_APPLICANT_DETAILS_FAILED,
  error
})
export const selectedApplicant = (selected) => ({
  type: SELECTED_APPLICANT,
  selected
})
export const updateViewApplication = (agreementId) => ({
  type: UPDATE_VIEW_APPLICATION,
  agreementId
})
export const updateReviewApplication = (uuid, appID, appJobID) => ({
  type: UPDATE_REVIEW_APPLICATION,
  uuid,
  appID,
  appJobID
})
export const updateReviewApplicationSuccess = (data) => ({
  type: UPDATE_REVIEW_APPLICATION_SUCCESS,
  data
})
export const updateReviewApplicationFailed = (error) => ({
  type: UPDATE_REVIEW_APPLICATION_FAILED,
  error
})
export const filterApplicants = (appJobID) => ({
  type: FILTER_APPLICANTS,
  appJobID
})
export const getTotalApplications = () => ({
  type: GET_TOTAL_APPLICATIONS
})
export const getTotalApplicationsSuccess = (data) => ({
  type: GET_TOTAL_APPLICATIONS_SUCCESS,
  data
})
export const getTotalApplicationsFailed = (error) => ({
  type: GET_TOTAL_APPLICATIONS_FAILED,
  error
})
export const rejectApplication = (
  appID,
  uuid,
  email,
  appJobID,
  applicantData
) => ({
  type: REJECT_APPLICATION,
  appID,
  uuid,
  email,
  appJobID,
  applicantData
})
export const rejectApplicationSuccess = (data) => ({
  type: REJECT_APPLICATION_SUCCESS,
  data
})
export const rejectApplicationFailed = (error) => ({
  type: REJECT_APPLICATION_FAILED,
  error
})
export const offerAssignment = (selected) => ({
  type: OFFER_ASSIGNMENT,
  selected
})
export const applicationsSaveAssignment = (formValues) => ({
  type: APPLICATION_SAVE_ASSIGNMENT,
  formValues
})
export const editAssignment = () => ({
  type: EDIT_ASSIGNMENT
})
export const previewAssignment = (formData, isDirectOffer) => ({
  type: PREVIEW_ASSIGNMENT,
  formData,
  isDirectOffer // directly offer is offer assignment agreement from Assignments page
})
export const previewAssignmentSuccess = (data) => ({
  type: PREVIEW_ASSIGNMENT_SUCCESS,
  data
})
export const previewAssignmentFailed = (error) => ({
  type: PREVIEW_ASSIGNMENT_FAILED,
  error
})
export const signAssignmentPad = (selectedOfferedData) => ({
  type: SIGN_ASSIGNMENT_PAD,
  selectedOfferedData
})
export const signSendContract = (
  trim,
  isDraft,
  offeredData,
  directlySendContract
) => ({
  type: SIGN_SEND_CONTRACT,
  trim,
  isDraft,
  offeredData,
  directlySendContract // Directly send contract from Light entrepreneurs or Assignments page
})
export const signSendContractSuccess = (data, isSigned) => ({
  type: SIGN_SEND_CONTRACT_SUCCESS,
  data,
  isSigned
})
export const signSendContractFailed = (error, isSigned) => ({
  type: SIGN_SEND_CONTRACT_FAILED,
  error,
  isSigned
})
export const rejectWarning = () => ({
  type: REJECT_WARNING
})
export const closeApplicationSnackbar = () => ({
  type: CLOSE_APPLICATION_SNACKBAR
})
export const updateApplicationStatus = (
  status,
  appliedjobid,
  appliedpersonuuid,
  appliedpersonemail,
  applicationid
) => ({
  type: UPDATE_APPLICATION_STATUS,
  status,
  appliedjobid,
  appliedpersonuuid,
  appliedpersonemail,
  applicationid
})
export const updateApplicationStatusSuccess = (data) => ({
  type: UPDATE_APPLICATION_STATUS_SUCCESS,
  data
})
export const updateApplicationStatusFailed = (error) => ({
  type: UPDATE_APPLICATION_STATUS_FAILED,
  error
})

export const getWorkshifts = () => ({
  type: GET_WORKSHIFTS
})
export const getWorkshiftsSuccess = (data) => ({
  type: GET_WORKSHIFTS_SUCCESS,
  data
})
export const getWorkshiftsFailed = (error) => ({
  type: GET_WORKSHIFTS_FAILED,
  error
})
export const getBillableHours = () => ({
  type: GET_BILLABLE_HOURS
})
export const getBillableHoursSuccess = (data) => ({
  type: GET_BILLABLE_HOURS_SUCCESS,
  data
})
export const getBillableHoursFailed = (error) => ({
  type: GET_BILLABLE_HOURS_FAILED,
  error
})
export const addWorkshifts = (formValues, selectedOfferTo) => ({
  type: ADD_WORKSHIFTS,
  formValues,
  selectedOfferTo
})
export const addWorkshiftsSuccess = (data) => ({
  type: ADD_WORKSHIFTS_SUCCESS,
  data
})
export const addWorkshiftsFailed = (error) => ({
  type: ADD_WORKSHIFTS_FAILED,
  error
})
export const getWorkshiftbyId = (workshiftId) => ({
  type: GET_WORKSHIFT_BY_ID,
  workshiftId
})
export const getWorkshiftbyIdSuccess = (data) => ({
  type: GET_WORKSHIFT_BY_ID_SUCCESS,
  data
})
export const getWorkshiftbyIdfailed = (error) => ({
  type: GET_WORKSHIFT_BY_ID_FAILED,
  error
})
export const confirmBillableHour = (values) => ({
  type: CONFIRM_BILLABLE_HOUR,
  values
})
export const confirmBillableHourSuccess = (data) => ({
  type: CONFIRM_BILLABLE_HOUR_SUCCESS,
  data
})
export const confirmBillableHourFailed = (error) => ({
  type: CONFIRM_BILLABLE_HOUR_FAILED,
  error
})
export const deleteWorkshift = (workshiftid, workshift_itemid) => ({
  type: DELETE_WORKSHIFT,
  workshiftid,
  workshift_itemid
})
export const cancelDialog = () => ({
  type: CANCEL_DIALOG
})
export const removeWorkshift = (workshiftid, workshift_itemid) => ({
  type: REMOVE_WORKSHIFT,
  workshiftid,
  workshift_itemid
})
export const removeWorkshiftSuccess = (data) => ({
  type: REMOVE_WORKSHIFT_SUCCESS,
  data
})
export const removeWorkshiftFailed = (error) => ({
  type: REMOVE_WORKSHIFT_FAILED,
  error
})
export const updateWorkshift = (formValues) => ({
  type: UPDATE_WORKSHIFT,
  formValues
})
export const updateWorkshiftSuccess = (data) => ({
  type: UPDATE_WORKSHIFT_SUCCESS,
  data
})
export const updateWorkshiftFailed = (error) => ({
  type: UPDATE_WORKSHIFT_FAILED,
  error
})
export const cancelEditWorkShift = () => ({
  type: CANCEL_EDIT_WORK_SHIFT
})
export const closeWorkShiftSnackbar = () => ({
  type: CLOSE_WORKSHIFT_SNACKBAR
})
export const getSignedLE = () => ({
  type: GET_SIGNED_LIGHT_ENTREPRENEUS
})
export const getSignedLESuccess = (data) => ({
  type: GET_SIGNED_LIGHT_ENTREPRENEUS_SUCCESS,
  data
})
export const getSignedLEFailed = (error) => ({
  type: GET_SIGNED_LIGHT_ENTREPRENEUS_FAILED,
  error
})
export const workshiftByEmail = (email) => ({
  type: WORKSHIFT_BY_EMAIL,
  email
})
export const workshiftPageChange = (selected) => ({
  type: WORKSHIFT_PAGE_CHANGE,
  selected
})
export const pinWorkshift = (workshift_itemid) => ({
  type: PIN_WORKSHIFT,
  workshift_itemid
})
export const pinWorkshiftSuccess = (data) => ({
  type: PIN_WORKSHIFT_SUCCESS,
  data
})
export const pinWorkshiftFailed = (error) => ({
  type: PIN_WORKSHIFT_FAILED,
  error
})
export const showWorkshiftFormDialog = () => ({
  type: SHOW_WORKSHIFT_FORM_DIALOG
})
export const closeWorkshiftFormDialog = () => ({
  type: CLOSE_WORKSHIFT_FORM_DIALOG
})

export const copyPreviousAssignment = () => ({
  type: COPY_PREVIOUS_ASSIGNMENT
})
export const copyPreviousAssignmentSuccess = (data) => ({
  type: COPY_PREVIOUS_ASSIGNMENT_SUCCESS,
  data
})
export const copyPreviousAssignmentFailed = (error) => ({
  type: COPY_PREVIOUS_ASSIGNMENT_FAILED,
  error
})

export const getOfferFromLightEntre = () => ({
  type: GET_OFFER_FROM_LIGHT_ENTRE
})
export const getOfferFromLightEntreSuccess = (data, directlyOfferData) => ({
  type: GET_OFFER_FROM_LIGHT_ENTRE_SUCCESS,
  data,
  directlyOfferData
})
export const getOfferFromLightEntreFailed = (error) => ({
  type: GET_OFFER_FROM_LIGHT_ENTRE_FAILED,
  error
})
export const applicationPageChange = (selected) => ({
  type: APPLICATION_PAGE_CHANGE,
  selected
})
export const pinApplication = (application_id, agreement_id) => ({
  type: PIN_APPLICATION,
  application_id,
  agreement_id
})
export const pinApplicationSuccess = (data) => ({
  type: PIN_APPLICATION_SUCCESS,
  data
})
export const pinApplicationFailed = (error) => ({
  type: PIN_APPLICATION_FAILED,
  error
})

export const getAreaOfWork = () => ({
  type: GET_AREA_OF_WORK
})
export const getAreaOfWorkSuccess = (data) => ({
  type: GET_AREA_OF_WORK_SUCCESS,
  data
})

export const getContract = (data) => ({
  type: GET_CONTRACT,
  data
})
export const getContractSuccess = (values) => ({
  type: GET_CONTRACT_SUCCESS,
  values
})
export const getContractFailed = (error) => ({
  type: GET_CONTRACT_FAILED,
  error
})

export const openAssignmentFormDialog = () => ({
  type: OPEN_ASSIGNMENT_FORM_DIALOG
})
export const closeAssignmentFormDialog = () => ({
  type: CLOSE_ASSIGNMENT_FORM_DIALOG
})
